import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'

// @material-ui
import { Grid, Card, CardActions, Typography, Button } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { withLang } from '_core/hocs/withLang'
import { getFormattedValue } from '_core/utils/formatPrice'
import { PriceMix } from '_core/components/PriceMix'
import { ProductListItemDetails } from '_core/components/ProductListItemDetails'

// style
import { useProductListItemStyle } from './productListItemStyle'

export const RawProductListItem = props => {
  const { data, getLangString: l, requestParams } = props
  const { goods, price, points } = data

  const theme = useTheme()
  const classes = useProductListItemStyle()

  const {
    config: { ROUTE_URL_PARAM, IS_SERVICE },
  } = useGlobal()

  const onView = location => {
    const search = new URLSearchParams(location.search)
    search.set(ROUTE_URL_PARAM.PRODUCT, goods.id)

    if (!isEmpty(requestParams)) {
      const keys = Object.keys(requestParams)
      keys.forEach(key => {
        search.set(key, requestParams[key])
      })
    }
    return { ...location, search: search.toString() }
  }

  const onPurchase = location => {
    const search = new URLSearchParams(location.search);
    if (requestParams.shop) search.set(ROUTE_URL_PARAM.SHOP, requestParams.shop);
    
    if (IS_SERVICE) {
      search.set(ROUTE_URL_PARAM.SERVICE, goods.id)
      search.set(ROUTE_URL_PARAM.AGREEMENT, goods.agreement)
    } else {
      search.set(ROUTE_URL_PARAM.PAYMENT, goods.id)
    }
    
    search.delete(ROUTE_URL_PARAM.PRODUCT);
    
    return { ...location, search: search.toString() };
  }

  const priceNode = (
    <PriceMix
      className={points > 0 ? classes.price : classes.row}
      rootProps={{
        noWrap: true,
        align: points === 0 ? 'center' : undefined,
      }}
      item={{
        ...price,
        currency: price.currency.id,
        hasTooltip: true,
        rootProps: { variant: 'h6', color: 'secondary' },
      }}
    />
  )

  const renderPrice = () =>
    points > 0 ? (
      <Grid container={true}>
        <Grid item={true} xs={12} sm={6} className={classes.column}>
          {priceNode}
        </Grid>

        <Grid item={true} xs={12} sm={6} className={classes.column}>
          <Typography
            align="right"
            variant="subtitle1"
            color="secondary"
            noWrap={true}
            className={classes.price}
          >
            {l(
              ['r._.goods.text.points', points],
              getFormattedValue(points, { scale: theme.variables.pointsScale })
            )}
          </Typography>
        </Grid>
      </Grid>
    ) : (
      priceNode
    )

  return (
    <Card className={classes.root}>
      <Link to={onView} className={classes.details}>
        <ProductListItemDetails data={goods}>
          <div className={classes.row}>{renderPrice()}</div>
        </ProductListItemDetails>
      </Link>

      <CardActions className={classes.actions}>
        <Button to={onView} size="small" variant="text" component={Link}>
          <Typography component="span" variant="overline" noWrap={true}>
            {l('r._.product.action.details')}
          </Typography>
        </Button>

        <Button to={onPurchase} component={Link}>
          {l('r._.product.action.buy')}
        </Button>
      </CardActions>
    </Card>
  )
}

RawProductListItem.defaultProps = {
  requestParams: {},
}

RawProductListItem.propTypes = {
  requestParams: PropTypes.object,

  // self props
  data: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const ProductListItem = withLang(RawProductListItem)
